export enum AuthorizationType {
  NONE,
  ACCESS_TOKEN,
  REFRESH_TOKEN,
}


